import { useEffect, useState } from "react";
import { req } from "./ServerUtils";
import { Dialog, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

export function OutreachProfileList() {
    const [profiles, setProfiles] = useState([]);
    const [showFullComment, setShowFullComment] = useState(null);

    useEffect(() => {
        req('/linkedin_outreach_profiles').then((data) => {
            setProfiles(data.profiles);
        });
    }, []);

    return (
        <div className="profiles-grid">
            <div className="grid-header">
                <div>No.</div>
                <div>Created At</div>
                <div>LinkedIn User ID</div>
                <div>Name</div>
                <div>Post</div>
                <div>Comment</div>
                <div>Design</div>
            </div>
            {profiles.map((profile, i) => (
                <div className="grid-row">
                    <div>{profiles.length - i}</div>
                    <div>{profile.created_at}</div>
                    <div>{profile.linkedin_user_id}</div>
                    <div>{profile.name}</div>
                    <div><a href={profile.post_link} target="_blank">Post</a></div>
                    <div className="comment-cell" onClick={() => {
                        setShowFullComment(profile.comment);
                    }}>{profile.comment}</div>
                    
                    <div>
                        <img src={preview_url(profile.design_metainfo)} alt="Design Preview" style={{
                            width: "100px",
                            height: "100px",
                            cursor: "pointer",
                        }} onClick={() => {
                            window.open(`https://app.makemybrand.ai/design/${profile.design_id}`, '_blank');
                        }}/>
                    </div>
                </div>
            ))}
            <style jsx>{`
                .profiles-grid {
                    display: grid;
                    gap: 8px;
                }
                .grid-header {
                    display: grid;
                    grid-template-columns: repeat(7, 1fr);
                    font-weight: bold;
                    background-color: #f5f5f5;
                    padding: 8px;
                }
                .grid-row {
                    display: grid;
                    grid-template-columns: repeat(7, 1fr);
                    padding: 8px;
                    border-bottom: 1px solid #eee;
                }
                .comment-cell {
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                }
            `}</style>
            <Dialog open={showFullComment !== null} onClose={() => setShowFullComment(null)}>   
                <DialogTitle>Comment</DialogTitle>
                <DialogContent>
                    <DialogContentText>{showFullComment}</DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    )
}

function preview_url(metainfo) {
    if (metainfo.png_urls) {
        return "https://cdn.makemybrand.ai/" + metainfo.png_urls[0].key;
    }
    return null;
}